export const PRODUCT_LOV_TYPES = {
    PRODUCT_LINE_COLOUR: 'PRODUCT_LINE_COLOUR',
    PRODUCT_STATUS: 'PRODUCT_STATUS',
    PRODUCT_CATEGORY: 'PROD_LN_CAT',
    PRODUCT_SUB_CATEGORY: 'PROD_LN_CAT_SUB',
    PRODUCT_SIZE: 'PRODUCT_SIZE',
    PRODUCT_BRAND: 'PRODUCT_BRAND',
    PRODUCT_TYPE: 'PRODUCT_TYPE',
    PRODUCT_SUB_TYPE: 'PRODUCT_TYPE_SUB',
    PRODUCT_UOM: 'PRODUCT_UOM',
    PRODUCT_MARGIN_TYPE: 'PRODUCT_MARGIN_TYPE',
}

export const PRODUCT_WEBSITE_LOV_TYPES = {
    PRODUCT_WEBSITE_STATUS: 'PRODUCT_WEBSITE_STATUS',
}

export const PRODUCT_PRICE_LIST_TYPE_LOV_TYPES = {
    PRODUCT_PRICE_LIST_TYPE: 'PRODUCT_PRICE_LIST_TYPE',
}

export const PRODUCT_PRICE_LIST_TAX_LOV_TYPES = {
    PRODUCT_PRICE_LIST_TAX: 'ORDER_TAX',
}

export const PRODUCT_REFRESH_PRICE_LIST_TYPE_LOV_TYPES = {
    REFRESH_PRICE_LIST_TYPE: 'REFRESH_PRICE_TYPE',
}